import { useState } from "react"
import { SincronizacaoHeader } from "./components/sincronizacao-header/sincronizacao-header"
import SincronizacaoList from "./components/sincronizacao-list/sincronizacao-list"
import { SincronizacaoListSearchProps } from "./components/sincronizacao-list/sincronizacao-list-search-props"
import { useDefaultSincronizacaoStyles } from "./sincronizacao-styles"
import { isEmpty } from "lodash"
import { Box, Typography } from "@material-ui/core"

export const SincronizacaoPage = () => {
    const classes = useDefaultSincronizacaoStyles()

    const [openPesquisa, setOpenPesquisa] = useState(true);
    const [filtro, setFiltro] = useState<SincronizacaoListSearchProps>({
        lojaId: '',
        lojaNome: '',
        dataFinal: '',
        dataInicio: '',
        aplicacao: ''
    })

    return (
        <>
            <div className={classes.root}>
                <div className={classes.header}>
                    <SincronizacaoHeader
                        openPesquisa={openPesquisa}
                        setSearchProps={setFiltro}
                        setOpenPesquisa={setOpenPesquisa}
                    />
                </div>
                {isEmpty(filtro.lojaId) && (
                    <Box width="100%">
                        <div className={classes.ultimoAcesso}>
                            <div className={classes.horario}>
                                <Typography className={classes.ultimoAcessoText}>
                                    Selecione uma loja acima para trazer as sincronizações caso tenha!
                                </Typography>
                            </div>
                        </div>
                    </Box>
                )}
                <SincronizacaoList searchProps={filtro} />
            </div>
        </>
    )
}